export type Spacing = 'none' | 'tiny' | 'small' | 'regular' | 'medium' | 'large' | 'larger' | 'xlarge';

export type SpacingTheme = {
  [key in Spacing]: number;
};

export default {
  none: 0,
  tiny: 0.25,
  small: 0.5,
  regular: 0.75,
  medium: 1,
  large: 1.5,
  larger: 2,
  xlarge: 2.5,
} as SpacingTheme;
